// ============================================================================
// EIN LANGER ZUFALLSWERT AUF KNOPFDRUCK.
//
//   ORIGINALTEXT MARVIN (06.09.2026)
//     „wo bekomme ich den n8n token her damit die kommunikation läuft und die
//      pushes von der neuen plattform kommen?"
//
// **DIE ANTWORT AUF SEINE FRAGE IST ZWEIGETEILT, UND DIESE DATEI IST DIE EINE
// HÄLFTE.** Manche Token bekommt man von jemandem (der Bot-Token von
// BotFather, der Token des Mailversands aus dem n8n-Ablauf, in dem er steht);
// die anderen DENKT MAN SICH AUS - `eingang.mail_token` und das Geheimnis des
// Telegram-Rückkanals. Bis heute stand an genau diesen Stellen der Satz „hier
// einen langen Zufallswert eintragen", und es gab keinen Knopf dafür.
//
// **EIN AUSGEDACHTES TOKEN IST SO GUT WIE DAS, WAS DEMJENIGEN GERADE
// EINFIEL.** Wer unter Zeitdruck eines braucht, tippt den Firmennamen mit
// einer Jahreszahl - und das ist die Sorte Geheimnis, die genau einmal
// funktioniert und danach in einer Nachricht steht.
//
// SIE ENTSTEHT IM BROWSER UND NICHT AUF DEM SERVER. Ein Weg
// `GET /zufallswert` wäre eine Route, die ein Geheimnis AUSLIEFERT: sie
// stünde in jedem Protokoll der Zwischenstellen und wäre die einzige Stelle
// dieses Hauses, an der ein Geheimnis über eine Leitung kommt, ohne dass es
// jemand gesetzt hat. `crypto.getRandomValues` liefert dasselbe, und der Wert
// verlässt den Rechner erst dann, wenn er wirklich gesetzt wird.
//
// SIE STEHT OHNE JSX DANEBEN, aus demselben Grund wie `namen.ts`,
// `terminraster.ts`, `klebeband.ts`, `kartenmass.ts`, `oberflaeche.ts`,
// `kartenebene.ts`, `grenzpunkte.ts`, `handbuchmarken.ts`,
// `tabellenbeschriftung.ts`, `zahlwoerter.ts` und `bruchstellen.ts`: **eine
// Textsuche misst, dass etwas dasteht, nicht, dass es stimmt.** Ob ein Wert
// wirklich lang genug ist und wirklich aus dem Zufallszahlengeber kommt,
// muss man ausrechnen.
// ============================================================================

/**
 * DAS ZEICHENVORRAT IST BASE64URL, und das ist keine Zier.
 *
 * Ein Token wird abgeschrieben, in eine Umgebungsvariable kopiert, in eine
 * Kopfzeile gesetzt und durch eine Adresse geschleift. Ein Zeichen, das dabei
 * seine Bedeutung ändert (`+`, `/`, `=`, ein Leerzeichen), kostet eine halbe
 * Stunde Fehlersuche an der falschen Stelle - man sucht beim Recht und nicht
 * bei der Kodierung. Dieselbe Entscheidung wie beim API-Schlüssel.
 */
const VORRAT =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

/**
 * WIE LANG. 40 Zeichen aus 64 Möglichkeiten sind 240 Bit - mehr, als ein
 * Angreifer je durchprobiert, und kurz genug, um in eine Zeile zu passen.
 */
export const LAENGE = 40;

/**
 * Einen Zufallswert bauen.
 *
 * **DER REST DER TEILUNG IST HIER FOLGENLOS UND WÄRE ES SONST NICHT.** 256
 * geteilt durch 64 geht auf; wäre der Vorrat 62 Zeichen lang (also ohne `-`
 * und `_`), kämen die ersten acht Zeichen häufiger vor als die übrigen, und
 * das ist genau die Sorte Schwäche, die niemandem auffällt. Der Vorrat ist
 * deshalb 64 Zeichen lang, und zwar mit Absicht.
 */
export function zufallswert(laenge = LAENGE): string {
  const bytes = new Uint8Array(laenge);
  crypto.getRandomValues(bytes);
  let s = '';
  for (const b of bytes) s += VORRAT[b % VORRAT.length];
  return s;
}

/**
 * Sieht dieser Wert aus wie einer, den niemand rät?
 *
 * Sie ist eine AUSKUNFT und kein Riegel: was jemand in ein Geheimnis
 * einträgt, entscheidet er - es gibt Dienste, deren Token anders aussieht
 * (der Bot-Token von Telegram trägt einen Doppelpunkt). Ein Riegel daraus
 * wäre eine Regel über ein fremdes System, und die ist beim nächsten Anbieter
 * falsch.
 */
export function taugtAlsGeheimnis(wert: string): boolean {
  const s = (wert ?? '').trim();
  return s.length >= 20 && /[0-9]/.test(s) && /[A-Za-z]/.test(s);
}
